module.exports = __webpack_public_path__ + "img/app-qrcode.2ebf1a57.png";